import { render } from "./CirculoTerms.vue?vue&type=template&id=2652447c&scoped=true"
import script from "./CirculoTerms.vue?vue&type=script&lang=js"
export * from "./CirculoTerms.vue?vue&type=script&lang=js"

import "./CirculoTerms.vue?vue&type=style&index=0&id=2652447c&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2652447c"]])

export default __exports__